import React from "react";
import Slider from "react-slick";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import { Link } from "react-router-dom/cjs/react-router-dom";

function SliderTwo() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    center: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          SlidesToScroll: 1,
        },
      },
      {
        breakpoint: 575,
        settings: {
          sidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };


  return (
    <section className="slider-area">
      <Slider className="slider-active" {...settings}>
        <div className="single-slider slider-bg slider-style-two">
          <div className="container-fluid container-full-padding">
            <div className="row">
              <div className="col-xl-8 col-lg-7 col-md-11">
                <div className="slider-content ">
                  <Fade up delay={0.4}>
                    <h6>world gaming</h6>
                  </Fade>

                  <Fade up delay={0.5}>
                    <h2>
                      Play <span>Create<br className="d-none d-xl-inline" /></span> Dominate
                    </h2>
                  </Fade>
                  <Fade up delay={0.5}>
                    <p>
                      Welcome to Obigin Media Labs — where imagination becomes
                      gameplay. We craft lightning‑fast HTML5, Android and
                      Smart TV titles that anyone can pick up and play.
                    </p>
                  </Fade>

                  <Fade up delay={0.8}>
                    <a href="/#android-games" className="btn btn-style-two">
                      Play Now
                    </a>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
          <Slide right delay={0.4}>
            <div className="slider-img ">
              <img src="Wizard-Character.webp" alt="" className="wizard-img" />
            </div>
          </Slide>
          <Slide left delay={0.4}>
            <div className="slider-img slider-img2 wow slideInRightS">
              <img
                src="Yello-Knight-Character.webp"
                alt=""
                className="wizard-img"
              />
            </div>
          </Slide>
          <div className="slider-circle-shape">
            <img
              src="assets/img/slider/slider_circle.webp"
              alt=""
              className="rotateme"
            />
          </div>
        </div>


        <div
          className="single-slider slider-bg slider-style-two"
        >
          <div className="container-fluid container-full-padding">
            <div className="row">
              <div className="col-xl-8 col-lg-7 col-md-11">
                <div className="slider-content">
                  <Fade up delay={0.4}>
                    <h6>world gaming</h6>
                  </Fade>
                  <Fade up delay={0.5}>
                    <h2>
                         Design <span>Develop<br className="d-none d-xl-inline" /></span> Deliver
                    </h2>
                  </Fade>
                  <Fade up delay={0.5}>
                    <p>
                      Our in-house team takes ideas from rough sketches to refined products, blending strategy, design, and development to deliver polished, revenue-ready hits — in weeks
                    </p>
                  </Fade>
                  <Fade up delay={0.8}>
                    <Link
                      to="/technology"
                      className="btn btn-style-two"
                    >
                      Explore Our Tech
                    </Link>
                  </Fade>
                </div>
              </div>
            </div>
          </div>
          <Slide right delay={0.4}>
            <div className="slider-img">
              <img
                src="/Viking-Character.webp"
                alt=""
                className="viking-character-img"
              />
            </div>
          </Slide>
          <Slide left delay={0.4}>
            <div className="slider-img slider-img2 slider-img3">
              <img
                style={{
                  marginRight: "150px",
                }}
                src="/rani.webp"
                alt="rani"
                className="rani-character-img"
              />
            </div>
          </Slide>
          <div className="slider-circle-shape">
            <img
              className="rotateme"
              src="assets/img/slider/slider_circle.webp"
              alt=""
            />
          </div>
        </div>
      </Slider>
    </section>
  );
}

export default SliderTwo;
